@if (installation()) {
  <ng-container>
    <!-- installer can still accept invite -->
    @if (!isCurrentInstallerConfirmed() && !hideButton()) {
      <ion-grid class="ion-margin-horizontal ion-padding-horizontal">
        <ion-row>
          <ion-col size-xs="12" size-sm="12" size-md="8">
            <h2>{{ 'invitation_title' | translate }}</h2>
            <p>{{ 'invitation_accept' | translate }}</p>
          </ion-col>
        </ion-row>
        <ion-row class="ion-no-padding">
          <ion-col class="details" size-xs="12" size-sm="12" size-md="6">
            <div class="ion-margin">
              <h2 class="ion-no-margin">
                {{ installation()?.owner?.firstname }}
                {{ installation()?.owner?.lastname }}
              </h2>
              <p class="ion-no-margin">
                @if (address() !== '') {
                  <ng-container>
                    {{ address() }}
                  </ng-container>
                } @else {
                  <ng-template>
                    {{ 'invitation_unknownAddress' | translate }}
                  </ng-template>
                }
              </p>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="ion-padding-vertical">
          <ion-col>
            <ion-button
              type="button"
              color="primary"
              (click)="acceptInstallationByInstaller()"
            >
              <small>{{ 'invitation_btn' | translate }}</small>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    }

    @if (!isCurrentInstallerConfirmed() && hideButton()) {
      <ion-grid class="ion-margin-horizontal ion-padding-horizontal">
        <ion-row>
          <ion-col size-xs="12" size-sm="12" size-md="8">
            <h2>{{ 'invitation_title' | translate }}</h2>
            <p>
              {{ 'invitation_acceptSuccess' | translate }}
              {{ 'invitation_acceptSuccessInfo' | translate }}
            </p>
          </ion-col>
        </ion-row>
        <ion-row class="ion-no-padding">
          <ion-col class="details" size-xs="12" size-sm="12" size-md="6">
            <div class="ion-margin">
              <h2 class="ion-no-margin">
                {{ installation()?.name }} -
                {{ installation()?.owner?.firstname }}
                {{ installation()?.owner?.lastname }}
              </h2>
              <p class="ion-no-margin">
                @if (address() !== '') {
                  <ng-container>
                    {{ address() }}
                  </ng-container>
                } @else {
                  <ng-template>
                    {{ 'invitation_unknownAddress' | translate }}
                  </ng-template>
                }
              </p>
            </div>
          </ion-col>
        </ion-row>
        <ion-row class="ion-padding-vertical">
          <ion-col>
            <ion-button
              type="button"
              color="primary"
              (click)="toInstallationClicked()"
            >
              <small>{{ 'invitation_toInstallation' | translate }}</small>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    }

    @if (isCurrentInstallerConfirmed()) {
      <!-- installer is already installer for this installation -->
      <ion-grid class="ion-margin-horizontal ion-padding-horizontal">
        <ion-row>
          <ion-col size-xs="12" size-sm="12" size-md="6">
            <h2>{{ 'invitation_title' | translate }}</h2>
            <p>{{ 'invitation_acceptAlready' | translate }}</p>
          </ion-col>
        </ion-row>
      </ion-grid>
    }
  </ng-container>
} @else {
  <ng-template>
    <ion-grid class="ion-margin-horizontal ion-padding-horizontal">
      <ion-row>
        <ion-col size-xs="12" size-sm="12" size-md="6">
          <h2>{{ 'invitation_title' | translate }}</h2>
          <p>{{ 'invitation_notFoundInfo' | translate }}</p>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-template>
}
